// components/Notifications/NotificationActionMenu.jsx
import React from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import { CheckCircleOutline, RadioButtonUnchecked, DoneAll } from "@mui/icons-material";
import { useMutation, useQueryClient } from "react-query";
import {
  markNotificationRead,
  markNotificationUnread,
  acknowledgeNotification,
} from "../../../api/services/notification";
import { QK } from "../../../base/qk";

const NotificationActionMenu = ({ anchorEl, onClose, notification, onRefetch }) => {
  const queryClient = useQueryClient();

  const markReadMutation = useMutation((id) => markNotificationRead(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([QK.notifications]);
      onRefetch();
    },
  });

  const markUnreadMutation = useMutation((id) => markNotificationUnread(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([QK.notifications]);
      onRefetch();
    },
  });

  const acknowledgeMutation = useMutation((id) => acknowledgeNotification(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([QK.notifications]);
      onRefetch();
    },
  });

  const handleMarkRead = () => {
    markReadMutation.mutate(notification.id);
    onClose();
  };

  const handleMarkUnread = () => {
    markUnreadMutation.mutate(notification.id);
    onClose();
  };

  const handleAcknowledge = () => {
    acknowledgeMutation.mutate(notification.id);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 160,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        },
      }}
    >
      {notification && !notification.is_read && (
        <MenuItem onClick={handleMarkRead} sx={{ gap: 1, py: 1 }}>
          <CheckCircleOutline sx={{ fontSize: 18, color: "#22c55e" }} />
          <Typography variant="body2">Mark as Read</Typography>
        </MenuItem>
      )}
      {notification && notification.is_read && (
        <MenuItem onClick={handleMarkUnread} sx={{ gap: 1, py: 1 }}>
          <RadioButtonUnchecked sx={{ fontSize: 18, color: "#64748b" }} />
          <Typography variant="body2">Mark as Unread</Typography>
        </MenuItem>
      )}
      {notification && !notification.is_acknowledged && (
        <MenuItem onClick={handleAcknowledge} sx={{ gap: 1, py: 1 }}>
          <DoneAll sx={{ fontSize: 18, color: "#3b82f6" }} />
          <Typography variant="body2">Acknowledge</Typography>
        </MenuItem>
      )}
    </Menu>
  );
};

export default NotificationActionMenu;